import CSLS from "./cs_local_storage";

// Apollo client instance will be set by App.js
let apolloClient = null;

export const CSAuth = {
    setApolloClient(client) {
        apolloClient = client;
    },
    clearShopClassesCache() {
        if (apolloClient) {
            // Clear specific queries related to shop classes
            apolloClient.cache.evict({
                fieldName: "scheduleClasses",
            });
            apolloClient.cache.gc(); // Garbage collect
            console.log("Shop classes cache cleared");
        }
    },
    login(tokenData) {
        // localStorage.setItem(CSLS.AUTH_TOKEN, tokenData.token)
        localStorage.setItem(CSLS.AUTH_TOKEN_EXP, tokenData.payload.exp);
        localStorage.setItem(
            CSLS.AUTH_TOKEN_ORIGIAT,
            tokenData.payload.origIat,
        );
        // localStorage.setItem(CSLS.AUTH_REFRESH_TOKEN, tokenData.refreshToken)
        localStorage.setItem(
            CSLS.AUTH_REFRESH_TOKEN_EXP,
            tokenData.refreshExpiresIn,
        );
        localStorage.removeItem(CSLS.AUTH_LOGIN_NEXT);
        // Clear shop classes cache to get fresh user-specific data
        this.clearShopClassesCache();
    },
    updateTokenInfo(refreshTokenData) {
        console.log("Token payload:");
        console.log(refreshTokenData);
        // localStorage.setItem(CSLS.AUTH_TOKEN, refreshTokenData.token)
        localStorage.setItem(CSLS.AUTH_TOKEN_EXP, refreshTokenData.payload.exp);
        localStorage.setItem(
            CSLS.AUTH_TOKEN_ORIGIAT,
            refreshTokenData.payload.origIat,
        );
        // localStorage.setItem(CSLS.AUTH_REFRESH_TOKEN, refreshTokenData.refreshToken)
        localStorage.setItem(
            CSLS.AUTH_REFRESH_TOKEN_EXP,
            refreshTokenData.refreshExpiresIn,
        );
    },
    cleanup() {
        console.warn("csauth cleanup called!");
        // Like logging out, but don't unset next url.
        // This function is used when a refreshToken has expired
        // localStorage.removeItem(CSLS.AUTH_TOKEN)
        localStorage.removeItem(CSLS.AUTH_TOKEN_EXP);
        localStorage.removeItem(CSLS.AUTH_TOKEN_ORIGIAT);
        // localStorage.removeItem(CSLS.AUTH_REFRESH_TOKEN)
        localStorage.removeItem(CSLS.AUTH_REFRESH_TOKEN_EXP);
        // Clear shop classes cache since user is no longer authenticated
        this.clearShopClassesCache();
        // Ensure the refreshing token flag is reset
        if (window.refreshingToken) {
            window.refreshingToken = false;
        }
    },
    logout(expired = false) {
        if (!expired) {
            // Manual logout, remove everything
            this.cleanup();
            localStorage.removeItem(CSLS.AUTH_LOGIN_NEXT);
        }
    },

    isAuthenticated() {
        const tokenExp = localStorage.getItem(CSLS.AUTH_TOKEN_EXP);
        return !!tokenExp && new Date() / 1000 < tokenExp;
    },

    isRefreshTokenValid() {
        const refreshTokenExp = localStorage.getItem(
            CSLS.AUTH_REFRESH_TOKEN_EXP,
        );
        return !!refreshTokenExp && new Date() / 1000 < refreshTokenExp;
    },
};
